<template>
  <div id="main-menu">
    <div class="row" style="height: 100px">
      <a href="#" @click="selectCreateMenu" class="action-button shadow animate green">
        <h1>Create</h1>
      </a>
    </div>
    <div class="row" style="height: 100px">
      <a href="#" class="action-button shadow animate blue"><h1>Join</h1></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'main-menu',
  methods: {
    selectCreateMenu () {
      this.$emit('menuCreateSelected')
    }
  }
}
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css?family=Pacifico');
  h1 {
    color: aliceblue;
  }
  .animate
  {
    transition: all 0.1s;
    -webkit-transition: all 0.1s;
  }

  .action-button {
    width: 100%;
    padding: 10px 40px;
    margin: 20px 30px 10px 30px;
    float: left;
    border-radius: 10px;
    font-family: 'Pacifico', cursive;
    font-size: 25px;
    color: #1e1e1e;
    text-decoration: none;
  }

  .blue
  {
    background-color: #3498DB;
    border-bottom: 5px solid #2980B9;
    text-shadow: 0px -2px #2980B9;
  }
  .green
  {
    background-color: #82BF56;
    border-bottom: 5px solid #669644;
    text-shadow: 0px -2px #669644;
  }
  .action-button:active
  {
    transform: translate(0px,5px);
    -webkit-transform: translate(0px,5px);
    border-bottom: 1px solid;
    animation: bounce-in 1s;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue